import styled from 'styled-components';

const PanelContainer = styled.div`
  background-color: white;
  border: 1px solid ${props => props.theme.carvana.lightGray};
  border-radius: 3px;
  padding: 30px;
`;

export default PanelContainer;
